// extracted by mini-css-extract-plugin
export var box = "_72-1";
export var checked = "_72-2";
export var descriptionSpacer = "_72-9";
export var disabled = "_72-3";
export var icon = "_72-6";
export var input = "_72-0";
export var labelSpacer = "_72-8";
export var medium = "_72-5";
export var small = "_72-4";
export var text = "_72-7";